import Vue from 'vue'
import App from './App.vue'
import router from './router'
import * as store from './store'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'
import * as firebase from 'firebase/app'

import { authService } from '@/auth/service'

Vue.config.productionTip = false

const isMobileApp = window.location.protocol === 'file:' || window.location.port === '3000'

// add cordova.js only if serving the app through file://
if (isMobileApp) {
  const cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
}

const firebaseConfig = {
  apiKey: 'AIzaSyCkI4u62tRTbxywSiOMqmlSGzM5txn93Z0',
  authDomain: 'app.remoteventures.com',
  // for local test
  // authDomain: 'remoteventures-86f56.firebaseapp.com',
  databaseURL: 'https://remoteventures-86f56.firebaseio.com',
  projectId: 'remoteventures-86f56',
  storageBucket: 'remoteventures-86f56.appspot.com',
  messagingSenderId: '633128299104',
  appId: '1:633128299104:web:a6cd6e663ad825543d7105',
  measurementId: 'G-MN6PDBLYGJ'
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)


// @ts-ignore
// alert("dddds " + !!JSON.stringify(window.cordova)) // JSON.stringify(device))
if ("cordova" in window) {
  document.addEventListener('deviceready', start)

} else {
  start()
}

function start() {

  Vue.prototype.authService = authService()
  Vue.component('apexchart', VueApexCharts)
  Vue.prototype.isMobileApp = "cordova" in window
  new Vue({
    router,
    store: store.instance(),
    vuetify,
    render: (h) => h(App)
  }).$mount('#app')

}
